import noUiSlider from 'nouislider'
import {debounce} from "chart.js/helpers";
import {setTariffFormButtonData} from "./tariffModal";
// range filter
document.addEventListener('DOMContentLoaded', function () {
    const isAddressThemeV1 = document.body.classList.contains('address-theme--v1');

    if (isAddressThemeV1) {
        // Инициализация слайдера цены
        const priceSlider = document.getElementById('price-slider');
        const priceMinInput = document.querySelector('.price-min');
        const priceMaxInput = document.querySelector('.price-max');

        noUiSlider.create(priceSlider, {
            start: [parseInt(priceMinInput.value), parseInt(priceMaxInput.value)],
            connect: true,
            tooltips: true,
            range: {
                'min': parseInt(priceMinInput.min),
                'max': parseInt(priceMaxInput.max)
            },
            step: 100,
            behaviour: 'tap-drag',
            format: {
                to: function (value) {
                    return Math.round(value);
                },
                from: function (value) {
                    return Number(value);
                }
            }
        });

        priceSlider.noUiSlider.on('update', function (values, handle) {
            const value = Math.round(values[handle]);
            if (handle === 0) {
                priceMinInput.value = value;
            } else {
                priceMaxInput.value = value;
            }
        });

        priceMinInput.addEventListener('change', function () {
            let value = parseInt(this.value) || parseInt(this.min);
            value = Math.max(parseInt(this.min), Math.min(parseInt(priceMaxInput.value), value));
            priceSlider.noUiSlider.set([value, null]);
            this.value = value;
        });

        priceMaxInput.addEventListener('change', function () {
            let value = parseInt(this.value) || parseInt(this.max);
            value = Math.max(parseInt(priceMinInput.value), Math.min(parseInt(this.max), value));
            priceSlider.noUiSlider.set([null, value]);
            this.value = value;
        });

        const speedSlider = document.getElementById('speed-slider');
        const speedMinInput = document.querySelector('.speed-min');
        const speedMaxInput = document.querySelector('.speed-max');

        noUiSlider.create(speedSlider, {
            start: [parseInt(speedMinInput.value), parseInt(speedMaxInput.value)],
            connect: true,
            tooltips: true,
            range: {
                'min': parseInt(speedMinInput.min),
                'max': parseInt(speedMaxInput.max)
            },
            step: 10,
            behaviour: 'tap-drag',
            format: {
                to: function (value) {
                    return Math.round(value);
                },
                from: function (value) {
                    return Number(value);
                }
            }
        });

        speedSlider.noUiSlider.on('update', function (values, handle) {
            const value = Math.round(values[handle]);
            if (handle === 0) {
                speedMinInput.value = value;
            } else {
                speedMaxInput.value = value;
            }
        });

        speedMinInput.addEventListener('change', function () {
            let value = parseInt(this.value) || parseInt(this.min);
            value = Math.max(parseInt(this.min), Math.min(parseInt(speedMaxInput.value), value));
            speedSlider.noUiSlider.set([value, null]);
            this.value = value;
        });

        speedMaxInput.addEventListener('change', function () {
            let value = parseInt(this.value) || parseInt(this.max);
            value = Math.max(parseInt(speedMinInput.value), Math.min(parseInt(this.max), value));
            speedSlider.noUiSlider.set([null, value]);
            this.value = value;
        });

// open details tariff
        let detailsController = new AbortController();

        function initOpenDetailsTariffs() {
            // Отменяем предыдущие обработчики
            detailsController.abort();
            detailsController = new AbortController();

            const detailButtons = document.querySelectorAll('.tariff-card__details');
            const signal = detailsController.signal;

            detailButtons.forEach(button => {
                button.addEventListener('click', function () {
                    const detailsContent = this.previousElementSibling;
                    const isExpanded = this.getAttribute('aria-expanded') === 'true';
                    const newState = !isExpanded;

                    this.setAttribute('aria-expanded', newState);
                    detailsContent.setAttribute('data-visible', newState);
                    this.style.marginTop = newState ? '20px' : '15px';
                }, {signal});
            });
        }

        initOpenDetailsTariffs();

//filter

        const tariffsSection = document.querySelector('.address-tariffs');
        const tariffsList = tariffsSection.querySelector('.address-tariffs__list');
        const selects = tariffsSection.querySelectorAll('.select-js');
        const loadMoreBtn = tariffsSection.querySelector('.address-tariffs__show-more');

        const desktopFiltersForm = document.querySelector('.address-tariffs__sidebar .filters-sidebar')

        const sidebar = tariffsSection.querySelector('.address-tariffs__sidebar');
        const filterOpenPopupButton = tariffsSection.querySelector('.address-tariffs__filter');
        const filterClosePopupButton = sidebar.querySelector('.filters-sidebar__close-popup');
        let tariffsCount = Number(tariffsList.dataset.tariffsCount);

        sidebar.addEventListener('click', function (event) {
            if (event.target === sidebar) {
                if (sidebar.style.display === 'flex') {
                    event.stopPropagation();
                    sidebar.style.display = 'none';
                }
            }
        })

        filterOpenPopupButton.addEventListener('click', function () {
            sidebar.style.display = 'flex';
        })
        filterClosePopupButton.addEventListener('click', function () {
            sidebar.style.display = 'none';
        })

        const applyFilterBtn = document.getElementById('apply-mobile-filters');

        function getHiddenCards () {
            return tariffsList.querySelectorAll('.tariff-card.hide');
        }
        function getCards () {
            return tariffsList.querySelectorAll('.tariff-card');
        }
        function showMoreHiddenTariffs() {
            const hiddenCards = getHiddenCards();
            Array.from(hiddenCards).slice(0, 10).forEach(card => {
                card.classList.remove('hide');
            });
        }

        function fetchTariffsWithFilters(offset = 0, form = null, onlyCount = false) {
            if (!form || !loadMoreBtn) return;
            const formData = new FormData(form);
            const params = new URLSearchParams();

            const defaultMinSpeed = parseInt(form.querySelector('.speed-min').getAttribute('min'));
            const defaultMaxSpeed = parseInt(form.querySelector('.speed-max').getAttribute('max'));

            const currentMinSpeed = parseInt(formData.get('min_speed'));
            const currentMaxSpeed = parseInt(formData.get('max_speed'));

            const speedChanged = currentMinSpeed !== defaultMinSpeed || currentMaxSpeed !== defaultMaxSpeed;

            for (let [key, value] of formData.entries()) {
                if (!value && value !== 0) continue;

                if (key === 'min_speed' || key === 'max_speed') {
                    if (speedChanged) {
                        params.append(key, value);
                    }
                    continue;
                }

                params.append(key, value);
            }
            params.set('chunkUrl', loadMoreBtn.dataset.chunkUrl);
            params.set('providersuri', loadMoreBtn.dataset.providersuri);
            params.set('offset', offset);
            params.set('limit', onlyCount ? 0 : loadMoreBtn.dataset.limit);
            params.set('type', loadMoreBtn.dataset.type || 'all');
            params.set('sort', loadMoreBtn.dataset.sort || 'popular');

            if (!onlyCount) {
                loadMoreBtn.disabled = true;
                loadMoreBtn.textContent = 'Загрузка...';
            }

            fetch(`/tariffs/house-tariffs-ajax?${params.toString()}`)
                .then(res => res.json())
                .then(data => {
                    // if (onlyCount) {
                    //     if (applyBtn) {
                    //         let count = data.count !== undefined ? data.count : 0;
                    //         let total = data.total !== undefined ? data.total : count;
                    //         applyBtn.innerHTML = `Показать ${count}${total && total !== count ? ' из ' + total : ''}`;
                    //     }
                    //     return;
                    // }
                    if (data.html === "" && offset === 0) {
                        tariffsList.innerHTML =
                            '<div class="page-content__alert none">Тарифы не найдены. <br>Попробуйте изменить параметры поиска.</div>';
                        return;
                    }
                    if (offset === 0) {
                        tariffsList.innerHTML = data.html;
                    } else {
                        tariffsList.insertAdjacentHTML('beforeend', data.html);
                    }
                    loadMoreBtn.dataset.offset = data.nextOffset;
                    if (!data.hasMore) {
                        loadMoreBtn.style.display = 'none';
                    } else {
                        loadMoreBtn.style.display = '';
                        loadMoreBtn.disabled = false;
                        loadMoreBtn.textContent = 'Показать еще тарифы';
                        tariffsCount = data.count;
                        document.querySelector(".address-tariffs__count").innerHTML = tariffsCount;
                    }

                    setTariffFormButtonData();
                    initOpenDetailsTariffs();
                })
                .catch(() => {
                    if (!onlyCount) {
                        loadMoreBtn.disabled = false;
                        loadMoreBtn.textContent = 'Ошибка, попробуйте еще раз';
                    }
                }).finally(() => {
            });
        }

        const handleFilterChange = () => {
            if (sidebar.style.display !== 'flex') {
                fetchTariffsWithFilters(0, desktopFiltersForm);
            }
        }
        priceSlider.noUiSlider.on('change', debounce(handleFilterChange, 500));
        speedSlider.noUiSlider.on('change', debounce(handleFilterChange, 500));
        desktopFiltersForm.addEventListener('change', debounce(handleFilterChange, 500));
        desktopFiltersForm.addEventListener('submit', debounce(handleFilterChange, 500));

        applyFilterBtn.addEventListener('click', function () {
            fetchTariffsWithFilters(0, desktopFiltersForm);
            sidebar.style.display = 'none';
        })

        let currentSort = 'popular'; // по умолчанию

        selects.forEach(select => {
            select.addEventListener('change', function () {
                currentSort = {
                    'Популярные': 'popular',
                    'Дешевые': 'min_cost',
                    'Быстрые': 'max_speed'
                }[this.value] || 'popular';
                if (loadMoreBtn) loadMoreBtn.dataset.sort = currentSort;
                if (loadMoreBtn) loadMoreBtn.dataset.offset = 0;
                if (loadMoreBtn) {
                    loadMoreBtn.disabled = true;
                    loadMoreBtn.textContent = 'Загрузка...';
                }
                fetchTariffsWithFilters(0, desktopFiltersForm);
            });
        });

        if (loadMoreBtn) {
            if (tariffsCount === getCards().length && getHiddenCards().length === 0) {
                loadMoreBtn.style.display = 'none';
            }
            loadMoreBtn.addEventListener('click', function () {
                if (getHiddenCards().length !== 0) {
                    showMoreHiddenTariffs();
                    if (tariffsCount === getCards().length && getHiddenCards().length === 0) {
                        loadMoreBtn.style.display = 'none';
                    }
                } else {
                    fetchTariffsWithFilters(parseInt(this.dataset.offset, 10), desktopFiltersForm);
                }
            });
        }

        const typeButtons = document.querySelectorAll('.tariffs-type__button');

        typeButtons.forEach(btn => {
            btn.addEventListener('click', function () {
                typeButtons.forEach(b => b.classList.remove('active'));
                this.classList.add('active');
                const type = this.dataset.type;
                if (loadMoreBtn) {
                    loadMoreBtn.dataset.type = type;
                    loadMoreBtn.dataset.offset = '0';
                    loadMoreBtn.dataset.sort = currentSort;
                    loadMoreBtn.disabled = true;
                    loadMoreBtn.textContent = 'Загрузка...';
                }
                fetchTariffsWithFilters(0, desktopFiltersForm);
            });
        });

        const btnPopular = document.querySelector('.tariffs-table-btn-popular');
        const btnCheap = document.querySelector('.tariffs-table-btn-cheap');
        const tablePopular = document.getElementById('tariffs-table-popular');
        const tableCheap = document.getElementById('tariffs-table-cheap');

        if (btnPopular && btnCheap && tablePopular && tableCheap) {
            btnPopular.addEventListener('click', function () {
                btnPopular.classList.add('active');
                btnCheap.classList.remove('active');
                tablePopular.style.display = '';
                tableCheap.style.display = 'none';
            });
            btnCheap.addEventListener('click', function () {
                btnCheap.classList.add('active');
                btnPopular.classList.remove('active');
                tableCheap.style.display = '';
                tablePopular.style.display = 'none';
            });
        }

        const providerCardBtns = document.querySelectorAll('.provider__card-button.show-tariffs');
        providerCardBtns.forEach(btn => {
            btn.addEventListener('click', function () {
                const providersCheckboxes = document.querySelectorAll('input[name="providers[]"]')
                const providerSlug = this.dataset.provider;
                providersCheckboxes.forEach(checkbox => {
                    checkbox.checked = checkbox.value === providerSlug;
                })

                fetchTariffsWithFilters(0, desktopFiltersForm);

                document.getElementById('tariffs').scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            })
        })
    }

    const filterButtons = document.querySelectorAll('.popular-tariffs .new-tariffs-list button');
    const tariffBlocks = document.querySelectorAll('.popular-tariffs .tariffs-filter-block');

    if (filterButtons.length > 0 && tariffBlocks.length > 0) {
        filterButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                const filter = this.getAttribute('data-filter');

                filterButtons.forEach(function(btn) {
                    btn.closest('li').classList.remove('is-active');
                });
                this.closest('li').classList.add('is-active');

                tariffBlocks.forEach(function(block) {
                    if (block.getAttribute('data-filter') === filter) {
                        block.classList.remove('hide');
                    } else {
                        block.classList.add('hide');
                    }
                });
            });
        });
    }
})
